"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const NotificationAttachmentURL = ({ notificationAttachment }) => {
    const { type, url } = notificationAttachment;
    const getIcon = () => {
        const iconStyle = { flex: 'none' };
        switch (type) {
            case 'IMAGE':
                return React.createElement(src_1.ImageIcon, { fill: src_1.charcoal, height: "20", style: iconStyle, width: "20", viewBox: "0 0 24 24" });
            case 'AUDIO':
                return React.createElement(src_1.AudioIcon, { fill: src_1.charcoal, style: iconStyle, height: "20", width: "20", viewBox: "0 0 24 24" });
            case 'VIDEO':
                return React.createElement(src_1.VideoIcon, { fill: src_1.charcoal, style: iconStyle, height: "20", width: "20", viewBox: "0 0 24 24" });
            default:
                return null;
        }
    };
    return (React.createElement("div", { style: { minWidth: 0, flex: '1 1 auto' } },
        React.createElement(src_1.Text, { text: "Rich Media Attachment", size: "small", label: true, textStyle: { color: src_1.steel } }),
        React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
            getIcon(),
            React.createElement(src_1.Text, { size: "large", text: url, textStyle: {
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    marginLeft: 8,
                    marginRight: 16,
                } }))));
};
exports.default = NotificationAttachmentURL;
